import TwoThumbsDraggableTrack from './TwoThumbsDraggableTrack';

export default TwoThumbsDraggableTrack;
